/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.28.0
 */

import { EInquiryTableType } from '@/main/pages/PageHistoryInquiry/types';

import { useLazyGetInquiryStateQuery, useLazyGetOtherInquiryStateQuery } from '../store';

/**
 * Use getInquiryState or getOtherInquiryState depending on @param inquiryTableType
 */
export const useInquiryStateRequest = ({
    inquiryTableType,
    pollingInterval,
}: {
    inquiryTableType: EInquiryTableType;
    pollingInterval: number;
}) => {
    const isDefaultInquiryTableType = inquiryTableType === EInquiryTableType.DEFAULT;

    const getInquiryResponse = useLazyGetInquiryStateQuery({ pollingInterval });
    const getOtherInquiryResponse = useLazyGetOtherInquiryStateQuery({ pollingInterval });

    if (isDefaultInquiryTableType) {
        return getInquiryResponse;
    } else {
        return getOtherInquiryResponse;
    }
};
